/* Panel lateral Vista previa (mismo chrome que FichaResumenPropiedad). */
import { useTheme } from "../ThemeProvider";
import { FichaResumenGaleria, FichaResumenVistaSecciones } from "./FichaResumenVistaSecciones";
import VistaPreviaRefPrecio from "./VistaPreviaRefPrecio";
import { FICHA_RESUMEN_ROOT_CLASS, fichaResumenFontSize } from "./fichaResumenTypography";
import "./fichaResumenTypography.css";

/**
 * @param {{ p: object, d: object, onClose: () => void, cargando?: boolean }} props
 */
export default function FichaResumenPanel({ p, d, onClose, cargando = false }) {
  const { theme } = useTheme();
  const t = theme.colors;

  return (
    <div
      className="fixed inset-0 flex justify-end"
      style={{ background: "rgba(0,0,0,0.4)", zIndex: 10050 }}
      onClick={onClose}
    >
      <div
        className={`w-[720px] max-w-full h-full shadow-2xl flex flex-col overflow-x-hidden ${FICHA_RESUMEN_ROOT_CLASS}`}
        style={{ background: t.bgCard }}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          className="flex items-center justify-between px-3 py-2 shrink-0"
          style={{ background: t.bgCard, borderBottom: `1px solid ${t.border}` }}
        >
          {cargando ? (
            <span className="text-sm" style={{ color: t.textMuted }}>
              Cargando...
            </span>
          ) : (
            <VistaPreviaRefPrecio
              prop={p || {}}
              className="pr-2 flex-1 min-w-0"
              fontSize={fichaResumenFontSize(14)}
            />
          )}
          <button type="button" onClick={onClose} className="text-xl shrink-0" style={{ color: t.textMuted }}>
            ✕
          </button>
        </div>

        {cargando ? (
          <div className="flex-1 flex items-center justify-center" style={{ color: t.textMuted }}>
            Cargando propiedad...
          </div>
        ) : !p ? (
          <div className="flex-1 flex items-center justify-center" style={{ color: t.textMuted }}>
            No se encontró la propiedad
          </div>
        ) : (
          <div className="px-3 pt-3 flex-1 min-h-0 overflow-y-auto overflow-x-hidden">
            <FichaResumenGaleria fotos={d?.fotos || []} videos={d?.videos || []} theme={theme} />
            <FichaResumenVistaSecciones p={p} d={d || p} theme={theme} />
          </div>
        )}
      </div>
    </div>
  );
}
